import { usePlayer } from '@/audio/store'
import { Sheet } from '@/components/ui'

import { QueueClearButton, QueueContents } from './QueueContents'
import { QueueFeedback, useCurrentQueueNotice } from './QueueFeedback'

export interface QueuePanelProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function QueuePanel({ open, onOpenChange }: QueuePanelProps) {
  const count = usePlayer((state) => state.queue.length)
  const notice = useCurrentQueueNotice()

  return (
    <Sheet
      open={open}
      onOpenChange={onOpenChange}
      title="Queue"
      footer={notice ? <QueueFeedback /> : undefined}
      description={count === 1 ? '1 song' : `${count} songs`}
      headerAction={<QueueClearButton onBeforeClear={() => onOpenChange(false)} />}
    >
      <QueueContents />
    </Sheet>
  )
}
